// @flow

import Game from '@/lib/game';

export default class {
  static isSatisfied(game: Game): boolean {
    const { beechAdultTreesCount } = game.stats;
    return beechAdultTreesCount >= 7 && game.virtualTime.season === 'spring';
  }

  static makeAchievement() {
    return {
      uid: 'beech_forest',
      title: 'カブトムシ取り放題',
      body: 'ブナの木がたくさん生えたので樹液にカブトムシが集まってきました。',
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/achievement_conditions/beech_forest.js